// src/utils/calc.ts

export const round2 = (v: number) => {
    const r = Math.round((v + Number.EPSILON) * 100) / 100;
    return Object.is(r, -0) ? 0 : r;
  };